import styled from '@emotion/styled';
import { useTranslate } from '@tolgee/react';
import { METRIC_META, NIL_TOOLTIP } from './constants';
import { formatMetricValue } from './utils';
import SpsStatusPill from './SpsStatusPill';

export interface SpsMetricCardProps {
  code: Dashboard.TikTokUS.MetricCode;
  /** 该指标的详情（未拿到时为 undefined，按数据不足渲染） */
  item?: Dashboard.TikTokUS.ShopMetricDetail;
  /** 蓝框 = 选中态 */
  selected: boolean;
  onClick: () => void;
}

function SpsMetricCard({ code, item, selected, onClick }: SpsMetricCardProps) {
  const { t } = useTranslate();
  const meta = METRIC_META[code];

  // status = NIL 表示未满足出分条件，**不是 0 分**
  const nil = !item || item.status === 'NIL';
  const topReason = item?.topReasonText?.trim();

  /*
   * 右上角**二选一**（定稿 C9），且设计稿里它是**带底色的胶囊**：
   * 有 topReasonText 就展示它（红底），否则展示 status 枚举；NIL 展示「数据不足」。
   */
  const cornerNode = nil ? (
    <SpsStatusPill status="NIL">{t(NIL_TOOLTIP)}</SpsStatusPill>
  ) : topReason ? (
    <SpsStatusPill status="CRITICAL">{topReason}</SpsStatusPill>
  ) : item ? (
    <SpsStatusPill status={item.status}>{item.status}</SpsStatusPill>
  ) : null;

  const valueText = nil ? '-' : formatMetricValue(item?.value, item?.valueUnit);

  return (
    <Card selected={selected} onClick={onClick}>
      <div className="flex items-center justify-between" style={{ gap: 8 }}>
        <span style={{ fontSize: 14 }}>
          {t(meta.nameZh)}（{code}）
        </span>
        {cornerNode}
      </div>
      <div className="mt-2">
        <span style={{ fontSize: 22, fontWeight: 600, lineHeight: 1.2 }}>{valueText}</span>
      </div>
    </Card>
  );
}

/**
 * 指标卡：两块**独立的白色区域**（父级留 gap，不是合并成一张卡）。
 * 选中态：边框转主题色，且**左边框加粗**（与设计稿一致）。
 */
const Card = styled.div<{ selected: boolean }>`
  flex: 1 0 0;
  padding: 12px 16px;
  cursor: pointer;
  background: var(--fett-bg-panel);
  border: 1px solid transparent;
  border-left: 3px solid transparent;
  border-radius: 4px;
  transition: border-color 0.2s;
  ${({ selected }) =>
    selected &&
    `
    border-color: var(--ant-primary-color);
    border-left-color: var(--ant-primary-color);
  `}
`;

export default SpsMetricCard;
